// export enum DealStatus {
//   notReviewed = 'not_reviewed',
//   approved = 'approved',
//   skipped = 'skipped',
// }

// export enum DealRelation {
//   acquired = 'ACQUIRED_RIGHTS_FOR',
//   deal = 'DEAL_WITH',
// }

// export enum DealType {
//   deal = 'deal',
//   acquisition = 'acquisition',
// }

// export enum EntityType {
//   company = 'COMPANY',
//   content = 'CONTENT',
//   person = 'PERSON',
// }

export enum RelationSourceType {
  SelfService = 'SelfService',
  DELI = 'DELI',
  OMDB = 'OMDB',
  Vitrina = 'Vitrina',
  Client = 'Client',
  TMDB = 'TMDB',
  // Gracenote = 'Gracenote',
  DealIntel = 'DealIntel',
  GVD = 'GVD',
 // JW = 'JW',
  // DealIntel='DealIntel',
  // MLGenerated='MLGenerated'
  //https://vdovitrina-ai.atlassian.net/wiki/spaces/VSDI/pages/432242763/Quadruple+updation
}

export enum IngestionMethod {
  DELI = 'DELI',
  SelfService = 'SelfService',
  CSV = 'CSV',
  XLS = 'XLS',
  Backend = 'Backend',
  // API = 'API',
  // FTP = 'FTP',
  // BackendProcess = 'BackendProcess',
}

export enum PublishStatusEnumNumeric {
  'Manually Unpublished' = -1,
  'Auto Unpublished' = 0,
  'Auto Published' = 1,
  'Manually Published' = 2,
}

export enum PublishStatus {
  'PS_-1' = 'Manually Unpublished',
  'PS_0' = 'Auto Unpublished',
  'PS_1' = 'Auto Published',
  'PS_2' = 'Manually Published',
}
